import React, { useState } from 'react';
import { toast } from 'react-toastify';

// Imports dos componentes MUI
import {
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Box,
  IconButton, InputAdornment
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DespesaExtraModal = ({ onClose, onSave }) => {
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState('');

  const handleSave = () => {
    const valorNumerico = parseFloat(valor);
    if (!descricao.trim() || !valor || isNaN(valorNumerico) || valorNumerico <= 0) {
      toast.warn('Por favor, preencha a descrição e um valor válido.');
      return;
    }
    
    onSave({
      descricao,
      valor: valorNumerico
    });
  };

  return (
    <Dialog open={true} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Lançar Despesa Extra
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box component="form" id="despesaForm" onSubmit={(e) => { e.preventDefault(); handleSave(); }} noValidate sx={{ mt: 1 }}>
          <TextField
            label="Descrição da Despesa"
            margin="normal"
            required
            fullWidth
            value={descricao}
            onChange={e => setDescricao(e.target.value)}
            autoFocus
          />
          <TextField
            label="Valor"
            type="number"
            margin="normal"
            required
            fullWidth
            value={valor}
            onChange={e => setValor(e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">R$</InputAdornment>,
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: '16px 24px' }}>
        <Button onClick={onClose} variant="outlined" color="inherit">Cancelar</Button>
        <Button type="submit" form="despesaForm" variant="contained" color="primary">
          Salvar Despesa
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DespesaExtraModal;